export default function anonymous(data, helper
/**/) {
    data = data || {};helper = helper || {};var _e = helper.escape ? helper.escape : function (s) {return s;};var _s = '<style type="text/css">' + (data.code == null ? '' : data.code) + '</style>';return _s;
};



/** WEBPACK FOOTER **
 ** ./src/template/css.js
 **/